import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.jpg'


const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row d-flex justify-content-between" }
const _hoisted_3 = { class: "col-6 logo" }
const _hoisted_4 = { class: "col-6 logo-cliente" }
const _hoisted_5 = ["src"]

import {computed, onBeforeMount, onMounted, onUnmounted} from "vue";
import {Synchronizer} from "@/synchronizer/service/Synchronizer";
import {useSettingsStore} from "@/core/stores/settings_store";
import {useRouter} from "vue-router";
import routes from "@/core/router/routes";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const synchronizer = new Synchronizer();
const router = useRouter();
let timer: number | null = null;
const settingsStore = useSettingsStore();
const companyLogo = computed(() => {
  if (!settingsStore.companyConfig.logo)
    return "";
  try {
    return require("@/assets/companies/" + settingsStore.companyConfig.logo);
  } catch (e) {
    console.error(e);
    return "";
  }
});

onBeforeMount(async () => {
  await settingsStore.init();
});

onMounted(() => {
  timer = setInterval(async () => {
    if (router.currentRoute.value.name != routes.send.name)
      await synchronizer.sync();
  }, 10_000);
});

onUnmounted(() => {
  if (timer)
    clearInterval(timer);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "logo"
                }, null, -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: companyLogo.value,
              alt: "company logo"
            }, null, 8, _hoisted_5)
          ])
        ])
      ])
    ]),
    _createElementVNode("main", null, [
      _createVNode(_component_router_view)
    ])
  ], 64))
}
}

})